export default __webpack_public_path__ + "static/media/hedwig-step-2.4a981ed8.png";